import { Link } from "react-router-dom";
import { Instagram, Facebook, Mail, Phone } from "lucide-react";
import { useSettings } from "../lib/useSettings";

export default function Footer() {
  const s = useSettings();
  const phoneE164 = s?.phone || "+1-780-655-7604";
  const phoneDisplay = s?.phone_display || "(780) 655-7604";
  const email = s?.email || "northcrestedmonton@gmail.com";
  const insta = s?.instagram_url || "https://www.instagram.com/northcrestlandscaping.edmonton/";
  const fb = s?.facebook_url || "https://www.facebook.com/profile.php?id=61590468096615";
  const brand = s?.business_name || "NorthCrest";
  return (
    <footer data-testid="main-footer" className="border-t border-[#D8D6D0]/10 bg-[#0d0d0d]">
      <div className="px-6 md:px-12 lg:px-16 py-20 grid grid-cols-1 md:grid-cols-4 gap-12">
        <div>
          <div className="flex items-center gap-3 mb-5">
            <img src="/logo.png" alt="NorthCrest" className="w-28 h-28 object-contain" />
            <div className="flex flex-col leading-none">
              <span className="font-serif-display text-3xl tracking-tight">NorthCrest</span>
              <span className="overline text-[11px] text-[#D8D6D0]/50 tracking-[0.3em] mt-1">Landscaping</span>
            </div>
          </div>
          <p className="text-sm text-[#D8D6D0]/60 leading-relaxed max-w-xs">
            Premium landscape construction & outdoor living. Edmonton, Alberta and surrounding areas.
          </p>
          <div className="mt-6 flex gap-4">
            <a href={insta} target="_blank" rel="noopener noreferrer" aria-label="Instagram" data-testid="social-instagram" className="text-[#D8D6D0]/60 hover:text-[#F5F3EF] transition-colors">
              <Instagram className="w-5 h-5" />
            </a>
            <a href={fb} target="_blank" rel="noopener noreferrer" aria-label="Facebook" data-testid="social-facebook" className="text-[#D8D6D0]/60 hover:text-[#F5F3EF] transition-colors">
              <Facebook className="w-5 h-5" />
            </a>
            <a href={`mailto:${email}`} aria-label="Email" data-testid="social-email" className="text-[#D8D6D0]/60 hover:text-[#F5F3EF] transition-colors">
              <Mail className="w-5 h-5" />
            </a>
          </div>
        </div>

        <div>
          <div className="overline text-[#D8D6D0]/50 mb-5">Studio</div>
          <ul className="space-y-3 text-sm text-[#D8D6D0]/80">
            <li><Link to="/about" className="link-underline">About</Link></li>
            <li><Link to="/projects" className="link-underline">Projects</Link></li>
            <li><Link to="/blog" className="link-underline">Journal</Link></li>
            <li><Link to="/contact" className="link-underline">Contact</Link></li>
          </ul>
        </div>

        <div>
          <div className="overline text-[#D8D6D0]/50 mb-5">Services</div>
          <ul className="space-y-3 text-sm text-[#D8D6D0]/80">
            <li><Link to="/services/residential" className="link-underline">Residential</Link></li>
            <li><Link to="/services/commercial" className="link-underline">Commercial</Link></li>
            <li><Link to="/yard-designer" className="link-underline">AI Yard Designer</Link></li>
            <li><Link to="/estimator" className="link-underline">Project Estimator</Link></li>
          </ul>
        </div>

        <div>
          <div className="overline text-[#D8D6D0]/50 mb-5">Service Areas</div>
          <ul className="space-y-3 text-sm text-[#D8D6D0]/80">
            <li><Link to="/areas/edmonton" className="link-underline">Edmonton</Link></li>
            <li><Link to="/areas/st-albert" className="link-underline">St. Albert</Link></li>
            <li><Link to="/areas/sherwood-park" className="link-underline">Sherwood Park</Link></li>
            <li><Link to="/areas/beaumont" className="link-underline">Beaumont</Link></li>
            <li><Link to="/areas/leduc" className="link-underline">Leduc</Link></li>
            <li><Link to="/areas/spruce-grove" className="link-underline">Spruce Grove</Link></li>
            <li><Link to="/areas/fort-saskatchewan" className="link-underline">Fort Saskatchewan</Link></li>
            <li><Link to="/areas" data-testid="footer-all-areas" className="overline text-[#8C1D30] hover:text-[#F5F3EF]">All Areas →</Link></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-[#D8D6D0]/10 px-6 md:px-12 lg:px-16 py-6 flex flex-col md:flex-row justify-between text-xs text-[#D8D6D0]/40">
        <div>
          © {new Date().getFullYear()} {brand.replace(/ Landscaping$/, "")} Landscaping. Edmonton, AB.
          <span className="mx-2 text-[#D8D6D0]/30">·</span>
          Website by{" "}
          <a
            href="https://webempire.ca/"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-webempire-link"
            className="hover:text-[#F5F3EF] underline underline-offset-2 transition-colors"
          >
            WebEmpire
          </a>
        </div>
        <div className="flex gap-6 mt-3 md:mt-0">
          <Link to="/privacy-policy" data-testid="footer-privacy-link" className="hover:text-[#F5F3EF] transition-colors">Privacy Policy</Link>
          <a href={`tel:${phoneE164}`} className="flex items-center gap-2 hover:text-[#F5F3EF] transition-colors"><Phone className="w-3 h-3" /> {phoneDisplay}</a>
          <a href={`mailto:${email}`} className="flex items-center gap-2 hover:text-[#F5F3EF] transition-colors"><Mail className="w-3 h-3" /> {email}</a>
        </div>
      </div>
    </footer>
  );
}
